export class MsContentFilter {
    private _section: number;
    private _part_from: number;
    private _part_to: number;
    private _treatise_from: number;
    private _treatise_to: number;
    private _chapter_from: number;
    private _chapter_to: number;
    private _structure: number;
    private _operator: string;

    constructor() {
        this.init();
    }

    init(): void {
        this._section = null;
        this._part_from = null;
        this._part_to = null;
        this._treatise_from = null;
        this._treatise_to = null;
        this._chapter_from = null;
        this._chapter_to = null;
        this._structure = null;
        this._operator = null;
    }

    get section(): number {
        return this._section;
    }

    set section(value: number) {
        if (value) {
            this._section = value;
        } else {
            this._section = null;
        }
    }

    get part_from(): number {
        return this._part_from;
    }

    set part_from(value: number) {
        if (value) {
            this._part_from = value;
        } else {
            this._part_from = null;
        }
    }

    get part_to(): number {
        return this._part_to;
    }

    set part_to(value: number) {
        if (value) {
            this._part_to = value;
        } else {
            this._part_to = null;
        }
    }

    get treatise_from(): number {
        return this._treatise_from;
    }

    set treatise_from(value: number) {
        if (value) {
            this._treatise_from = value;
        } else {
            this._treatise_from = null;
        }
    }

    get treatise_to(): number {
        return this._treatise_to;
    }

    set treatise_to(value: number) {
        if (value) {
            this._treatise_to = value;
        } else {
            this._treatise_to = null;
        }
    }

    get chapter_from(): number {
        return this._chapter_from;
    }

    set chapter_from(value: number) {
        if (value) {
            this._chapter_from = value;
        } else {
            this._chapter_from = null;
        }
    }

    get chapter_to(): number {
        return this._chapter_to;
    }

    set chapter_to(value: number) {
        if (value) {
            this._chapter_to = value;
        } else {
            this._chapter_to = null;
        }
    }

    get structure(): number {
        return this._structure;
    }

    set structure(value: number) {
        if (value) {
            this._structure = value;
        } else {
            this._structure = null;
        }
    }

    get operator(): string {
        return this._operator;
    }

    set operator(value: string) {
        if (value) {
            this._operator = value;
        } else {
            this._operator = null;
        }
    }

    getAsObject(): Object {
        const contentFilter: Object = new Object();
        if (this._section) {
            contentFilter['section'] = this._section;
        }
        if (this._part_from) {
            contentFilter['part_from'] = this._part_from;
        }
        if (this._part_to) {
            contentFilter['part_to'] = this._part_to;
        }
        if (this._treatise_from) {
            contentFilter['treatise_from'] = this._treatise_from;
        }
        if (this._treatise_to) {
            contentFilter['treatise_to'] = this._treatise_to;
        }
        if (this._chapter_from) {
            contentFilter['chapter_from'] = this._chapter_from;
        }
        if (this._chapter_to) {
            contentFilter['chapter_to'] = this._chapter_to;
        }
        if (this._structure) {
            contentFilter['structure'] = this._structure;
        }
        if (this._operator) {
            contentFilter['operator'] = this._operator;
        }
        return contentFilter;
    }

}




// WEBPACK FOOTER //
// ./src/app/models/ms-content-filter.ts